import { useState } from "react";
import { LuChevronDown, LuChevronUp, LuCheck, LuX, LuMinus } from "react-icons/lu";
import type { CheckResultsProps } from "../_types";

export function CheckResults({ checks, expanded: initialExpanded = false }: CheckResultsProps) {
  const [expanded, setExpanded] = useState(initialExpanded);

  if (!checks.dnsbl.checked && !checks.disposable.checked) {
    return (
      <div className="text-xs text-[var(--color-text-subtle)] italic">
        No checks performed yet
      </div>
    );
  }

  return (
    <div className="mt-2">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-1 text-xs text-[var(--color-text-muted)] hover:text-[var(--color-text)] transition-colors"
      >
        {expanded ? <LuChevronUp className="w-3 h-3" /> : <LuChevronDown className="w-3 h-3" />}
        {expanded ? "Hide details" : "Show details"}
      </button>

      {expanded && (
        <div className="mt-3 space-y-3 text-xs">
          {/* DNSBL Results */}
          <div>
            <div className="font-medium text-[var(--color-text)] mb-1">Blacklist Status</div>
            <div className="space-y-1">
              {checks.dnsbl.listedOn.length > 0 ? (
                checks.dnsbl.listedOn.map((bl) => (
                  <div key={bl.list} className="flex items-center gap-2 text-[var(--color-error)]">
                    <LuX className="w-3 h-3" />
                    <span>Listed on {bl.list}</span>
                  </div>
                ))
              ) : (
                <div className="flex items-center gap-2 text-[var(--color-success)]">
                  <LuCheck className="w-3 h-3" />
                  <span>Not listed on any blacklists ({checks.dnsbl.clean.length} checked)</span>
                </div>
              )}
            </div>
          </div>

          {/* Disposable Check */}
          <div>
            <div className="font-medium text-[var(--color-text)] mb-1">Disposable Email Detection</div>
            {checks.disposable.isListed ? (
              <div className="flex items-center gap-2 text-[var(--color-error)]">
                <LuX className="w-3 h-3" />
                <span>Detected by: {checks.disposable.detectedBy.join(", ")}</span>
              </div>
            ) : (
              <div className="flex items-center gap-2 text-[var(--color-success)]">
                <LuCheck className="w-3 h-3" />
                <span>Not detected as disposable</span>
              </div>
            )}
          </div>

          {/* DNS Records */}
          <div>
            <div className="font-medium text-[var(--color-text)] mb-1">DNS Configuration</div>
            <div className="space-y-1">
              <div className={`flex items-center gap-2 ${checks.dns.mxValid ? "text-[var(--color-success)]" : "text-[var(--color-warning)]"}`}>
                {checks.dns.mxValid ? <LuCheck className="w-3 h-3" /> : <LuMinus className="w-3 h-3" />}
                <span>MX Records: {checks.dns.mxValid ? checks.dns.mxRecords.join(", ") : "Not configured"}</span>
              </div>
              <div className={`flex items-center gap-2 ${checks.dns.spfValid ? "text-[var(--color-success)]" : "text-[var(--color-text-muted)]"}`}>
                {checks.dns.spfValid ? <LuCheck className="w-3 h-3" /> : <LuMinus className="w-3 h-3" />}
                <span>SPF Record: {checks.dns.spfValid ? "Configured" : "Not configured"}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
